import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const LegalMarketplace = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default LegalMarketplace